module.exports = {"sld:ColorMapEntry":[{"quantity":-999,"color":"#FFFFFF","label":"NO DATA"},{"quantity":0,"color":"#D7D7D7","label":"0"},{"quantity":0.001,"color":"#198CDB","label":"<=0.34"},{"quantity":0.03,"color":"#91E3AD","label":"0.34 - 0.95"},{"quantity":0.06,"color":"#DEFFB0","label":"0.95 - 1.71"},{"quantity":0.1,"color":"#FFE68C","label":"1.71 - 2.7"},{"quantity":9,"color":"#FF9982","label":"2.7 - 4.15"},{"quantity":12,"color":"#FF4D30","label":"4.15 - 8.14"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/county_maize_wheat_rice_mme_1981_2016_lcr_70_wheat.json
// module id = E6qC
// module chunks = 171